import type { GetServerSideProps } from 'next';
import type { ShowroomAppProps } from './_app';
import type { NextPage } from 'next';
import type { Content } from 'types/Content.interface';

import getCache from 'cache/cache';
import isLoggedIn from 'utils/isLoggedIn';

import Layout from 'layouts/Layout';
import TemplateFactory from 'templates/TemplateFactory';
import GeneralError from "components/GeneralError";
import FloatingNewsLetter from 'components/FloatingNewsletter';

export const getServerSideProps: GetServerSideProps = async ({ req, res, resolvedUrl }) => {
  try {
    const isAuthenticated = isLoggedIn(req, res);
    const { data, xCacheNext } = await getCache<Content>(
      `${process.env.API_URI}/api/v1/pages${resolvedUrl}`,
      isAuthenticated,
      req.headers.cookie as string
    );
    res.setHeader('x-cache-next', xCacheNext);

    if (data?.http_code === 301) {
      return {
        props: {},
        redirect: {
          destination: data.redirect,
          permanent: false,
        }
      }
    }
    return {
      props: data,
    };
  } catch (error: any) {
    return {
      notFound: error?.response?.status === 404,
      props: {}
    };
  }
};

interface PageProps extends ShowroomAppProps, Content { }

const LandingPage: NextPage<PageProps> = ({ isAuthenticated, page }) => {
  return (
    !page ? <Layout title="Ajdå :*(" isAuthenticated={isAuthenticated} meta={[]}>
      <GeneralError />
    </Layout> :
      <>
        <Layout title={page?.title} meta={page?.meta} isAuthenticated={isAuthenticated}>
          <TemplateFactory sections={page?.sections} />
          {/* <FloatingNewsLetter /> */}
        </Layout>
      </>
  );
};

export default LandingPage;
